module.exports = __webpack_public_path__ + "img/navigation-close.142b1228.svg";